
import React from "react";
import { Users, UserRoundPlus } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";

interface SelectedTeamMembersProps {
  selectedFreelancers: any[];
  removeFromTeam: (id: string | number) => void;
}

export const SelectedTeamMembers: React.FC<SelectedTeamMembersProps> = ({
  selectedFreelancers,
  removeFromTeam
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <UserRoundPlus className="h-5 w-5 text-indigo-500" />
          Selected Team Members ({selectedFreelancers.length}/5)
        </CardTitle>
      </CardHeader>
      <CardContent>
        {selectedFreelancers.length > 0 ? (
          <div className="space-y-4">
            {selectedFreelancers.map((freelancer) => (
              <div 
                key={freelancer.id} 
                className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-100"
              >
                <div className="flex items-center gap-3">
                  <Avatar>
                    <AvatarImage src={freelancer.avatar} />
                    <AvatarFallback>{freelancer.name.charAt(0)}</AvatarFallback>
                  </Avatar>
                  <div>
                    <div className="font-medium">{freelancer.name}</div>
                    <div className="text-sm text-gray-500">{freelancer.title}</div>
                  </div>
                </div>
                <Button 
                  variant="ghost" 
                  size="sm" 
                  onClick={() => removeFromTeam(freelancer.id)}
                  className="text-gray-500 hover:text-red-500"
                >
                  Remove
                </Button>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center p-6 text-gray-500">
            <Users className="h-10 w-10 mx-auto mb-4 text-gray-300" />
            <p>No team members selected yet.</p>
            <p className="text-sm mt-1">Use the search below to find and add team members.</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
